import { Injectable } from '@angular/core';
import {
    DatiqAnalyticsInputInteraction,
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_STRING,
    IDatiqAnalyticsEventInputInfo,
} from '@dat/datiq-core/models';
import { IDatiqButton } from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqButtonMapperService {
    constructor() {}

    mapClickInputInfo(settings: IDatiqButton): IDatiqAnalyticsEventInputInfo {
        const inputId: string = this.mapClickInputInfoId(settings);
        const interaction: DatiqAnalyticsInputInteraction =
            DatiqAnalyticsInputInteraction.Click;
        const label: string = this.mapClickInputInfoLabel(settings);
        const value: unknown = this.mapClickInputInfoLabel(settings);
        const props: unknown = this.mapClickInputInfoProps(settings);

        return {
            inputId,
            interaction,
            label,
            value,
            props,
            settings,
        };
    }

    mapClickInputInfoProps(settings: IDatiqButton): unknown {
        return settings?.props || {};
    }

    mapClickInputInfoLabel(settings: IDatiqButton): string {
        return settings?.label ?? DATIQ_DEFAULT_STRING;
    }

    mapClickInputInfoId(settings: IDatiqButton): string {
        return settings?.id;
    }
}
